import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { CommonModule, DatePipe } from '@angular/common';
import { BrowserStorageService } from '../../shared/services/common/browser-storage.service';
import { ApiCallsService } from '../../shared/services/network/api-calls.service';
import { DATE_TIME_FORMAT, MAX_SIZE, TIME_FORMAT } from '../../utils/constants';
import { api } from '../../utils/endpoints';
import { fileDirectories } from '../../utils/view-settings';

import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ViewStorePopupComponent } from '../../shared/popups/view-store-popup/view-store-popup.component';
import { UserService } from '../../shared/services/user.service';
import { SafeHtmlPipe } from '../../shared/validators/safe-html.pipe';
import { ICONS } from '../../utils/svg-icons';

@Component({
  selector: 'app-common-event-list',
  imports: [DatePipe, CommonModule, NgbTooltipModule, RouterLink, SafeHtmlPipe],
  templateUrl: './common-event-list.component.html',
  styleUrl: './common-event-list.component.scss',
})
export class CommonEventListComponent {
  fileDirectoriesPath: any = fileDirectories.profile;
  eventList: any = [];
  id: any;
  @Output() events = new EventEmitter<any>();
  DATE_TIME_FORMAT = DATE_TIME_FORMAT;
  TIME_FORMAT = TIME_FORMAT;
  @Input() Upcomming: any;
  @Input() sportId: any;
  userInfo: any;
  pagination = { limit: 3, maxSize: MAX_SIZE, skip: 0, totalItems: 0, row: 0, text: 'Loading...' };
  ICONS = ICONS;
  constructor(
    private _router: Router,
    private _storageService: BrowserStorageService,
    private _apiService: ApiCallsService,
    private _ngbModal: NgbModal,
    private _userService: UserService,
  ) {}
  ngOnInit(): void {
    this._getEventList(1);
    this._userService.user.subscribe((user) => {
      if (user) {
        this.userInfo = user;
      }
    });
  }
  private _getEventList(page: number): void {
    this._apiService.post(api._eventListing, this._getRequest(page)).subscribe({
      next: (res: any) => {
        if (res) {
          this.pagination.row = res.data.rows.length;
          this.pagination.text = 'No record found!';
          this.eventList = res?.data.rows;
          this.events.emit(res?.data.count);
        }
      },
      error: (error: any) => console.log(error),
    });
  }
  private _getRequest(page: any): HttpParams {
    let currentPage = Number.isNaN(parseInt(page)) || page == 0 ? 1 : parseInt(page);
    let params: any = {};
    if (this.sportId) {
      let array = [];
      array.push(this.sportId.toString());
      params['sportId'] = array;
    }
    if (this.Upcomming) {
      params['eventStatus'] = ['UPCOMING'];
    }
    params['page'] = currentPage;
    params['limit'] = this.pagination.limit;
    params['eventListType'] = 'publicEvents';
    return params;
  }
  vieweventDetails(data: any) {
    console.log(data);
    let adminDetail = this._storageService.getItem('userDetail');
    if (adminDetail) {
      this._router.navigate(['/events/eventByOthers/' + data.id]);
    } else {
      let modalRef = this._ngbModal.open(ViewStorePopupComponent, {
        scrollable: false,
        backdrop: 'static',
        keyboard: false,
        size: 'filterPopup',
        centered: true,
      });
    }
  }
  sportDetails(sports: any) {
    let adminDetail = this._storageService.getItem('userDetail');
    if (adminDetail) {
      this._router.navigate(['/sports/' + sports.sportId]);
    } else {
      let modalRef = this._ngbModal.open(ViewStorePopupComponent, {
        scrollable: false,
        backdrop: 'static',
        keyboard: false,
        size: 'filterPopup',
        centered: true,
      });
    }
  }
  tooltopAray(order: any) {
    let Array: any = [];
    order.map((item: any) => {
      Array.push(item?.sport?.name);
    });
    return Array.join(', ');
  }
}
